import { STORE_URLS } from '../config';

/**
 * Pair of official Google Play + App Store badges, sized for hero and
 * footer use. SVG sources live in `/badges/` and follow each store's
 * branding guidelines.
 */
export default function StoreBadges({
  size = 'lg',
  align = 'start',
}: {
  size?: 'sm' | 'lg';
  align?: 'start' | 'center';
}) {
  const height = size === 'lg' ? 'h-14' : 'h-11';
  const alignment = align === 'center' ? 'justify-center' : 'justify-start';

  return (
    <div className={`flex flex-wrap items-center gap-4 ${alignment}`}>
      <a
        href={STORE_URLS.android}
        target="_blank"
        rel="noopener noreferrer"
        className="btn-store"
        aria-label="Get Dinar Pulse on Google Play"
      >
        <img
          src="/badges/google-play.svg"
          alt="Get it on Google Play"
          className={`${height} w-auto`}
          loading="eager"
        />
      </a>
      <a
        href={STORE_URLS.ios}
        target="_blank"
        rel="noopener noreferrer"
        className="btn-store"
        aria-label="Download Dinar Pulse on the App Store"
      >
        <img
          src="/badges/app-store.svg"
          alt="Download on the App Store"
          className={`${height} w-auto`}
          loading="eager"
        />
      </a>
    </div>
  );
}
